var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.proceed($event)
        },
        keydown: function($event) {
          return _vm.todoForm.errors.clear($event.target.name)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { attrs: { for: "" } }, [
            _vm._v(_vm._s(_vm.trans("todo.title")))
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.todoForm.title,
                expression: "todoForm.title"
              }
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              value: "",
              name: "title",
              placeholder: _vm.trans("todo.title")
            },
            domProps: { value: _vm.todoForm.title },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.todoForm, "title", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _c("show-error", {
            attrs: { "form-name": _vm.todoForm, "prop-name": "title" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { attrs: { for: "" } }, [
            _vm._v(_vm._s(_vm.trans("todo.date")))
          ]),
          _vm._v(" "),
          _c("datepicker", {
            attrs: {
              bootstrapStyling: true,
              placeholder: _vm.trans("todo.date")
            },
            on: {
              selected: function($event) {
                return _vm.todoForm.errors.clear("date")
              }
            },
            model: {
              value: _vm.todoForm.date,
              callback: function($$v) {
                _vm.$set(_vm.todoForm, "date", $$v)
              },
              expression: "todoForm.date"
            }
          }),
          _vm._v(" "),
          _c("show-error", {
            attrs: { "form-name": _vm.todoForm, "prop-name": "date" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { attrs: { for: "" } }, [
            _vm._v(_vm._s(_vm.trans("todo.description")))
          ]),
          _vm._v(" "),
          _c("autosize-textarea", {
            attrs: {
              rows: "2",
              name: "description",
              placeholder: _vm.trans("todo.description")
            },
            model: {
              value: _vm.todoForm.description,
              callback: function($$v) {
                _vm.$set(_vm.todoForm, "description", $$v)
              },
              expression: "todoForm.description"
            }
          }),
          _vm._v(" "),
          _c("show-error", {
            attrs: { "form-name": _vm.todoForm, "prop-name": "description" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-info waves-effect waves-light pull-right",
          attrs: { type: "submit" }
        },
        [
          _vm.id
            ? _c("span", [_vm._v(_vm._s(_vm.trans("general.update")))])
            : _c("span", [_vm._v(_vm._s(_vm.trans("general.save")))])
        ]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          directives: [
            { name: "show", rawName: "v-show", value: _vm.id, expression: "id" }
          ],
          staticClass:
            "btn btn-danger waves-effect waves-light pull-right m-r-10",
          attrs: { to: "/todo" }
        },
        [_vm._v(_vm._s(_vm.trans("general.cancel")))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }